// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addIcons } from '@inovex.de/elements/dist/collection/util/icons';
import { ICON_PATHS } from '@inovex.de/elements/dist/inovex-elements/ino-icon/index.esm.js';

addIcons(ICON_PATHS);

export * from './components';

export * from './types';
